// Mock data for Fatimia Community Services Society of BC
// A Farsi Speaking Afghan Shi'a Muslim Centre

export const socialLinks = {
  facebook: "https://www.facebook.com/Fatimiacss/",
  instagram: "https://www.instagram.com/fatimiacss",
  whatsapp: "https://chat.whatsapp.com/D0bXILRGKvk8KlvsI4oven",
  youtube: "https://www.youtube.com/fatimiacss/live"
};

export const prayerTimes = {
  fajr: "4:45 AM",
  sunrise: "5:58 AM",
  dhuhr: "1:15 PM",
  sunset: "8:52 PM",
  maghrib: "9:12 PM",
  lastUpdated: "2025-08-15"
};

export const upcomingEvents = [
  {
    id: 1,
    title: "Weekly Majlis - Jummah",
    date: "2025-08-15",
    time: "1:00 PM",
    description: "Join us for the weekly Friday congregation and sermon.",
    location: "Main Prayer Hall"
  },
  {
    id: 2,
    title: "Muharram Program",
    date: "2025-08-25",
    time: "7:00 PM",
    description: "Special majalis commemorating the martyrdom of Imam Hussain (AS).",
    location: "Main Prayer Hall"
  },
  {
    id: 3,
    title: "Sisters Quran Study Circle",
    date: "2025-08-17",
    time: "10:00 AM",
    description: "Weekly Quran study and discussion group for sisters.",
    location: "Sisters Hall"
  },
  {
    id: 4,
    title: "Youth Islamic Workshop",
    date: "2025-08-23",
    time: "2:00 PM",
    description: "Interactive workshop on Islamic history and values for youth.",
    location: "Community Center"
  }
];

export const donationCategories = [
  {
    id: 1,
    title: "General Fund",
    description: "Support the daily operations of the mosque",
    icon: "Heart"
  },
  {
    id: 2,
    title: "Building Fund",
    description: "Contribute to mosque expansion and maintenance",
    icon: "Building2"
  },
  {
    id: 3,
    title: "Nazr",
    description: "Fulfill your vows and intentions",
    icon: "Star"
  },
  {
    id: 4,
    title: "Sadaqah",
    description: "Voluntary charity for those in need",
    icon: "HandHeart"
  },
  {
    id: 5,
    title: "Khums",
    description: "Fulfill your religious obligation",
    icon: "Scale"
  },
  {
    id: 6,
    title: "Zakat",
    description: "Annual obligatory charity",
    icon: "Coins"
  },
  {
    id: 7,
    title: "Other",
    description: "Specify your own donation purpose",
    icon: "Star"
  }
];

export const volunteerOpportunities = [
  {
    id: 1,
    title: "Event Coordination",
    description: "Help organize and coordinate community events and programs."
  },
  {
    id: 2,
    title: "Madrassah",
    description: "Assist teachers in the Madrassah with Islamic education for children."
  },
  {
    id: 3,
    title: "Kitchen and Cleaning",
    description: "Help prepare and serve food, and maintain cleanliness of the center."
  },
  {
    id: 4,
    title: "Building Maintenance",
    description: "Assist with repairs, upkeep, and maintenance of the facility."
  }
];

export const aboutContent = {
  aboutUs: "As followers of the Shia tradition, we believe in the importance of seeking knowledge, cultivating virtue, and serving in the way of the Ahlul-Bayt (as). Our centre is a place where you can find resources to help you on this path, including weekly supplications, religious classes, and volunteer opportunities. We are committed to promoting a culture of compassion, generosity, and solidarity, and we invite you to be a part of this effort.",
  mission: "Our Mission is to provide an Islamic community center for the Muslim families and youth, to channel the energy of the youth towards serving Allah by engaging them in positive community services, and to deliver the message of Islam to the public: spirituality, peace & compassion.",
  vision: "A strong Shia Muslim Community, where families & youth are vibrantly engaged in religious and community service, while embodying our values.",
  values: [
    "Integrity and dignity",
    "Unity & teamwork",
    "Honesty & transparency",
    "Learning & education",
    "Respect",
    "Compassion & empathy"
  ],
  history: "Established to serve the growing Shi'a Muslim community in British Columbia, Fatimia Community Services Society has been a beacon of faith and service. Our center provides a space for daily prayers, religious education, and community programs that strengthen our bond with Allah (SWT) and each other."
};

export const madrassahInfo = {
  description: "Our Madrassah program provides comprehensive Islamic education for children and youth, covering Quran recitation, Islamic history, Fiqh, and Akhlaq.",
  ageGroups: [
    { name: "Beginners (Ages 5-7)", schedule: "Sundays 10:00 AM - 12:00 PM" },
    { name: "Intermediate (Ages 8-11)", schedule: "Sundays 10:00 AM - 1:00 PM" },
    { name: "Advanced (Ages 12-15)", schedule: "Sundays 10:00 AM - 2:00 PM" },
    { name: "Teen Program (Ages 16+)", schedule: "Sundays 11:00 AM - 2:00 PM" }
  ],
  subjects: [
    "Quran Recitation & Tajweed",
    "Islamic History (Tareekh)",
    "Jurisprudence (Fiqh)",
    "Ethics & Morals (Akhlaq)",
    "Arabic Language Basics",
    "Lives of the Ahlul Bayt (AS)"
  ]
};

export const youthProgramInfo = {
  description: "The Fatimia Youth Group is dedicated to fostering a sense of community among the youth, while also deepening our understanding of our faith and exploring relevant topics that affect us in our daily lives.",
  additionalInfo: "We offer a wide range of activities, from weekly discussion groups and educational seminars to social events and volunteer opportunities.",
  vision: "We believe that by coming together, sharing our experiences, and learning from one another, we can build a stronger, more vibrant community to serve in the way of the Ahlul-bayt (as).",
  ageRange: "14-30",
  activities: [
    {
      title: "Weekly Discussion Groups",
      description: "Engage in meaningful conversations about faith, life, and contemporary issues."
    },
    {
      title: "Educational Seminars",
      description: "Learn from scholars and experts on various Islamic and life topics."
    },
    {
      title: "Social Events",
      description: "Build connections and friendships through community gatherings and activities."
    },
    {
      title: "Volunteer Opportunities",
      description: "Give back to the community and serve in the way of the Ahlul-bayt (as)."
    }
  ]
};

export const membershipInfo = {
  description: "Join our community and be part of a thriving Shi'a Muslim congregation. We welcome Associated Member applications from all families and individuals who wish to be part of our community.",
  registrationLink: "https://forms.gle/G9ELndqMKr8Txpt8A",
  benefits: [
    "Voting rights in community decisions",
    "Priority registration for programs and events",
    "Access to member-only resources",
    "Discounts on facility rentals",
    "Regular community newsletter"
  ]
};

export const contactInfo = {
  address: "10906 Larson Rd. Surrey, BC V3V 3Y8",
  phone: "(604)-229-1819",
  email: "info@fatimia.ca",
  hours: {
    weekdays: "9:00 AM - 9:00 PM",
    weekends: "8:00 AM - 10:00 PM"
  }
};

// Helper function to get Islamic (Hijri) date
export const getIslamicDate = () => {
  const today = new Date();
  const gregorianDate = today.toLocaleDateString('en-US', { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });
  
  // Approximate Hijri date (for demo purposes)
  const hijriDate = "18 Safar 1447 AH";
  
  return {
    gregorian: gregorianDate,
    hijri: hijriDate
  };
};
